"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var core_1 = require("@material-ui/core");
var icons_1 = require("../../../../common/icons");
var components_1 = require("../../../../common/components");
var utils_1 = require("../utils");
var constants_1 = require("../constants");
var translate_1 = __importDefault(require("../../../../app/localization/translate"));
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a, _b, _c;
    return ({
        root: (_a = {
                background: theme.palette.common.white,
                color: theme.palette.common.black,
                borderRadius: theme.youwell.shapes.borderRadiusFlatter,
                marginTop: theme.spacing(1),
                padding: theme.spacing(1.5),
                display: 'flex',
                alignItems: 'center',
                width: '100%'
            },
            _a[theme.breakpoints.down('xs')] = {
                flexDirection: 'column',
                justifyContent: 'space-between',
                alignItems: 'flex-end',
            },
            _a),
        entry: (_b = {
                marginRight: theme.spacing(8),
                display: 'flex',
                alignItems: 'center'
            },
            _b[theme.breakpoints.down('xs')] = {
                width: '100%',
                marginRight: theme.spacing(0),
                marginBottom: theme.spacing(1),
            },
            _b),
        entryLabel: (_c = {
                marginRight: theme.spacing(2)
            },
            _c[theme.breakpoints.down('xs')] = {
                flex: '1 1 auto',
            },
            _c),
        flex: {
            flex: '1 1 auto',
        },
        deleteIcon: {
            color: theme.palette.secondary.main,
        },
        notValidInput: {
            color: theme.palette.error.main,
            marginTop: theme.spacing(1),
        },
    });
}, { name: 'DaytimeNaps' });
var DaytimeNap = function (_a) {
    var value = _a.value, onChange = _a.onChange, onDelete = _a.onDelete, date = _a.date, daytimeNaps = _a.daytimeNaps, listIndex = _a.listIndex, validationItem = _a.validationItem;
    var classes = useStyles();
    var translate = (0, translate_1.default)();
    var validateInput = function (name, changedValue) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
        if (!daytimeNaps)
            return true;
        var currWakeTime = (_b = (_a = daytimeNaps[listIndex]) === null || _a === void 0 ? void 0 : _a.wakeTime) !== null && _b !== void 0 ? _b : null;
        var prevWakeTime = (_d = (_c = daytimeNaps[listIndex - 1]) === null || _c === void 0 ? void 0 : _c.wakeTime) !== null && _d !== void 0 ? _d : null;
        var currSleepTime = (_f = (_e = daytimeNaps[listIndex]) === null || _e === void 0 ? void 0 : _e.sleepTime) !== null && _f !== void 0 ? _f : null;
        var nextSleepTime = (_h = (_g = daytimeNaps[listIndex + 1]) === null || _g === void 0 ? void 0 : _g.sleepTime) !== null && _h !== void 0 ? _h : null;
        var prevSleepTime = (_k = (_j = daytimeNaps[listIndex - 1]) === null || _j === void 0 ? void 0 : _j.sleepTime) !== null && _k !== void 0 ? _k : null;
        var validation = true;
        if (name === utils_1.sleepLoggingItemNames.sleepTime) {
            if (currSleepTime) {
                var isLaterThanPrevWakeTimeOrPrevSleepTime = prevWakeTime ? (0, utils_1.validateTimeLaterThanWithActualDate)(prevWakeTime, date, utils_1.SleepLoggingType.dayLogging)(changedValue) : prevSleepTime ? (0, utils_1.validateTimeLaterThanWithActualDate)(prevSleepTime, date, utils_1.SleepLoggingType.dayLogging)(changedValue) : true;
                var isLaterThanCurrWakeTimeOrNextSleepTime = currWakeTime ? (0, utils_1.validateTimeLaterThanWithActualDate)(currWakeTime, date, utils_1.SleepLoggingType.dayLogging)(changedValue) : nextSleepTime ? (0, utils_1.validateTimeLaterThanWithActualDate)(nextSleepTime, date, utils_1.SleepLoggingType.dayLogging)(changedValue) : false;
                validation = isLaterThanPrevWakeTimeOrPrevSleepTime && !isLaterThanCurrWakeTimeOrNextSleepTime;
            }
        }
        if (name === utils_1.sleepLoggingItemNames.wakeTime) {
            if (currWakeTime) {
                var isLaterThanNextSleepTime = nextSleepTime ? (0, utils_1.validateTimeLaterThanWithActualDate)(nextSleepTime, date, utils_1.SleepLoggingType.dayLogging)(changedValue) : false;
                var isLaterThanCurrSleepTime = currSleepTime ? (0, utils_1.validateTimeLaterThanWithActualDate)(currSleepTime, date, utils_1.SleepLoggingType.dayLogging)(changedValue) : true;
                validation = isLaterThanCurrSleepTime && !isLaterThanNextSleepTime;
            }
        }
        return validation;
    };
    var handleChange = function (name) { return function (changedValue) {
        var _a;
        onChange(__assign(__assign({}, value), (_a = {}, _a[name] = (0, utils_1.getTimeWithActualDate)(changedValue, date), _a)));
    }; };
    var validation = function (name, newValue) {
        var _a, _b;
        if ((validationItem === null || validationItem === void 0 ? void 0 : validationItem.length) > 0) {
            if (name === utils_1.sleepLoggingItemNames.sleepTime && ((_a = validationItem[0]) === null || _a === void 0 ? void 0 : _a.validation.sleep) === false) {
                return validateInput(utils_1.sleepLoggingItemNames.sleepTime, value.sleepTime);
            }
            if (name === utils_1.sleepLoggingItemNames.wakeTime && ((_b = validationItem[0]) === null || _b === void 0 ? void 0 : _b.validation.wake) === false) {
                return validateInput(utils_1.sleepLoggingItemNames.wakeTime, value.wakeTime);
            }
        }
        return validateInput(name, newValue);
    };
    return (React.createElement(React.Fragment, null,
        value.wakeTime && !value.sleepTime && (React.createElement(core_1.Typography, { className: classes.notValidInput }, translate('sleepDiary.mustApplySleepTime'))),
        React.createElement("div", { className: classes.root },
            React.createElement("div", { className: classes.entry },
                React.createElement(core_1.Typography, { variant: "subtitle1", className: classes.entryLabel }, translate('sleepDiary.fellAsleep')),
                React.createElement(components_1.TimePicker, { value: value.sleepTime, onChange: handleChange(utils_1.sleepLoggingItemNames.sleepTime), validation: function (d) { return validation(utils_1.sleepLoggingItemNames.sleepTime, d); }, defaultValue: constants_1.defaultDaytimeSleepTime, validateWithoutValueChange: true })),
            React.createElement("div", { className: classes.entry },
                React.createElement(core_1.Typography, { variant: "subtitle1", className: classes.entryLabel }, translate('sleepDiary.wokeUp')),
                React.createElement(components_1.TimePicker, { value: value.wakeTime, onChange: handleChange(utils_1.sleepLoggingItemNames.wakeTime), validation: function (d) { return validation(utils_1.sleepLoggingItemNames.wakeTime, d); }, defaultValue: constants_1.defaultDaytimeWakeTime, validateWithoutValueChange: true })),
            React.createElement("div", { className: classes.flex }),
            React.createElement(core_1.IconButton, { onClick: onDelete, size: "small" },
                React.createElement(icons_1.DeleteIcon, { className: classes.deleteIcon })))));
};
DaytimeNap.defaultProps = {
    daytimeNaps: null,
};
exports.default = DaytimeNap;
